import { axiosInstance } from '../request';
export const getLiveKitRoomToken = async (data) => {
    const response = await axiosInstance.get(`/api/v1/livekit/room-token?timezone=${data.timezone}&client=${data.client}`);
    return response.data;
};
//# sourceMappingURL=livekit.api.js.map